// apps/web/src/lib/sessionToken.ts
// Bearer-token storage for the native app. Kept in Capacitor Preferences
// (UserDefaults) — unlike localStorage on capacitor://localhost, WebKit never
// purges it under storage pressure. Web builds never store a token (the
// server only issues X-Session-Token to the native origin).
import { isNativeApp } from "./native";

const KEY = "caloly_session_token";

let token: string | null = null;
// Single-flight as a SHARED PROMISE. The old boolean flag was set before the
// async read finished, so of the parallel requests fired at app boot (me,
// entitlement, …) only the first actually waited for the stored token — the
// rest raced past with token still null, the auth check went out without its
// bearer, and every native launch landed on the login screen despite a
// perfectly persisted session (tester bug report). Everyone now awaits the
// same load.
let loadPromise: Promise<void> | null = null;

export function ensureTokenLoaded(): Promise<void> {
  loadPromise ??= !isNativeApp()
    ? Promise.resolve() // web has nothing to hydrate
    : (async () => {
        try {
          const { Preferences } = await import("@capacitor/preferences");
          token = (await Preferences.get({ key: KEY })).value;
        } catch { /* plugin unavailable (old binary) — cookie path still works */ }
      })();
  return loadPromise;
}

export function getToken(): string | null {
  return token;
}

export async function setToken(next: string | null): Promise<void> {
  token = next;
  if (!isNativeApp()) return;
  try {
    const { Preferences } = await import("@capacitor/preferences");
    if (next) await Preferences.set({ key: KEY, value: next });
    else await Preferences.remove({ key: KEY });
  } catch { /* best-effort */ }
}
